import { SET_INPUT_RATING } from './ratings-actions';
export const ratingsReducer = (state, action) => {
    switch (action.type) {
        case SET_INPUT_RATING: {
            return { ...state, ratings: { ...state.ratings, inputRating: action.payload.rating } };
        }
    }
};
//# sourceMappingURL=ratings-reducer.js.map